import {
  ConfigurationPolicyCompleteDTO,
  UIConfigurationDTO
} from "../models/app-config.model";

export const DEFAULT_UI_CONFIGURATION: UIConfigurationDTO = {
  id: null,
  configurationPolicyId: null,
  logoImage: "",
  logoImageType: null,
  loadingImage: "assets/img/favicon/favicon.png",
  loadingImageType: null,
  title: "DriveB Fleet",
  senderEmail: "donotreply@bosch-frotas.com.br",
  supportEmail: "suporte.driveb@br.bosch.com",
  gradientInitColor: "#ffffff",
  gradientFinalColor: "#007bc0",
  sidebarBackgroundColor: "#283f5e",
  sidebarTextColor: "#ffffff",
  sidebarBackgroundSelectedColor: "#1e324d",
  primaryButtonBackgroundColor: "#007bc0",
  primaryButtonBorderColor: "#007bc0",
  primaryButtonTextColor: "#ffffff",
  secondaryButtonBackgroundColor: "#ffffff",
  secondaryButtonBorderColor: "#007bc0",
  secondaryButtonTextColor: "#007bc0",
  tertiaryButtonBackgroundColor: "#ffffff",
  tertiaryButtonBorderColor: "#a1191d",
  tertiaryButtonTextColor: "#a1191d"
};

export function getDefaultConfigurationPolicyCompleteMock(): ConfigurationPolicyCompleteDTO {
  return {
    configurationPolicy: null,
    uiConfiguration: { ...DEFAULT_UI_CONFIGURATION }
  };
}
